export default {
  version: (state) => state.version,
  maintenance: (state) => state.maintenance
};
